module.exports = __webpack_public_path__ + "img/img_29.2f8afb3e.png";